import { useTranslation } from "react-i18next";
import { Button, ButtonProps } from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

interface Props {
  text?: string;
  onClick?: ButtonProps["onClick"];
}
export default function SignInButton({ text, onClick }: Props) {
  const { t } = useTranslation("components");

  return (
    <Button
      color="primary"
      data-testid="login__signin-btn"
      disableElevation
      fullWidth
      onClick={onClick}
      size="large"
      startIcon={
        <ExitToAppIcon style={{ marginRight: "5px", fontSize: "20px" }} />
      }
      type="submit"
      variant="contained"
    >
      {text || t("landing.signIn")}
    </Button>
  );
}
